import PropTypes from 'prop-types';
import styled from 'styled-components';

import { brandColors } from '@constants/styles';

const BaseCard = styled.div`
  overflow: hidden;
  background-color: ${(props) =>
    brandColors[props.backgroundColor] ? brandColors[props.backgroundColor] : 'white'};
  border-radius: ${(props) => props.borderRadius};
  padding: ${(props) => props.padding};
`;

BaseCard.defaultProps = {
  className: '',
  backgroundColor: '',
  borderRadius: '0',
  padding: '0',
};

BaseCard.propTypes = {
  className: PropTypes.string,
  borderRadius: PropTypes.string,
  padding: PropTypes.string,
};

export default BaseCard;
